import { api, ApiResponse } from "../lib/api";
import { MainPageData } from "../entry/server/movie";
import { AppLinks, GatewayData, MenuData, NotificationData, PlanData, TicketData, TicketMessageData } from "../entry/server/app";
import { UserVIPData } from "../entry/server/user";

export const appService = {
    getHomePageData: async () => {
        return await api.get<MainPageData>({ url: "main-page" });
    },
    getMenuData: async () => {
        return await api.get<MenuData>({ url: "menu-data", revalidate: 60 * 60 * 4 });
    },
    getAppLinks: async () => {
        return await api.get<AppLinks>({ url: "app-links" });
    },
    getTickets: async (page: number) => {
        return await api.get<TicketData[]>({ url: "tickets", queryParams: { page: page.toString() } });
    },
    getTicket: async (ticketId: number) => {
        return await api.get<{ ticket: TicketData, messages: TicketMessageData[] }>({ url: `tickets/${ticketId}` });
    },
    createTicket: async (title: string, priority: 'low' | 'medium' | 'high' | 'critical', description: string) => {
        return await api.post<TicketData>({ url: "tickets", body: { title, priority, description } });
    },
    replyToTicket: async (ticketId: number, content: string): Promise<ApiResponse<TicketData>> => {
        return await api.post<TicketData>({ url: `tickets/${ticketId}/reply`, body: { content } });
    },
    getPlans: async () : Promise<ApiResponse<PlanData[]>> => {
        return await api.get<PlanData[]>({ url: "plans", revalidate: 60 * 60 * 24 });
    },
    getGateways: async () : Promise<ApiResponse<GatewayData[]>> => {
        return await api.get<GatewayData[]>({ url: "gateways" });
    },
    applyDiscountCode: async (code: string) : Promise<ApiResponse<PlanData[]>> => {
        return await api.get<PlanData[]>({ url: 'discount', queryParams: { code } });
    },
    createPayment: async (planId: number, gatewayId: number, discountCode?: string) : Promise<ApiResponse<string>> => {
        return await api.get<string>({ url: `create-payment/${gatewayId}/${planId}`, queryParams: { discount_code: (discountCode !== null && discountCode !== undefined ? discountCode : '') } });
    },
    verifyPayment: async (paymentId: number) : Promise<ApiResponse<UserVIPData>> => {
        return await api.get<UserVIPData>({ url: `verify-payment/${paymentId}` });
    },
    createWalletPayment: async (amount: number, gatewayId: number) : Promise<ApiResponse<string>> => {
        return await api.get<string>({ url: `create-wallet-payment/${gatewayId}/${amount}` });
    },
    verifyWalletPayment: async (paymentId: number) : Promise<ApiResponse<void>> => {
        return await api.get<void>({ url: `verify-payment/${paymentId}` });
    },
    getNotifications: async (page: number) : Promise<ApiResponse<NotificationData[]>> => {
        return await api.get<NotificationData[]>({ url: "users/notifications", queryParams: { page: page.toString() } });
    },
    markAllNotificationsAsRead: async () : Promise<ApiResponse<void>> => {
        return await api.post<void>({ url: "users/notifications/read" });
    }
};